/*
 * bk-sticky-atc.js
 * Mobile Sticky-ATC: spiegelt Preis/Verfuegbarkeit vom Haupt-Preisblock und proxyt
 * den Klick auf den echten Buy-Box-CTA (.bk-bb__cta). Keine eigene Warenkorb-Logik.
 */
(function () {
  function initBar(bar) {
    if (bar.__bkInit) return;
    bar.__bkInit = true;

    var sectionId = bar.getAttribute('data-section');
    var scope = bar.closest('.shopify-section') || document;
    var mainCta = scope.querySelector('.bk-bb__cta');
    var buyrow = scope.querySelector('.bk-bb__buyrow');
    var priceWrap = scope.querySelector('[data-dynamic-variant-content="' + sectionId + '-price"]');
    var stickyPrice = bar.querySelector('[data-bk-sticky-price]');
    var stickyCta = bar.querySelector('[data-bk-sticky-cta]');
    var stickyLabel = bar.querySelector('[data-bk-sticky-label]');
    if (!mainCta || !buyrow) return;

    // --- Preis spiegeln (Variantenwechsel re-rendert priceWrap via Section-Rendering-API) ---
    // NUR .price__current spiegeln: snippets/price.liquid rendert daneben .price__was
    // (Streichpreis), .price__from und den Grundpreis — die gehoeren nicht in die Leiste.
    function syncPrice() {
      if (!priceWrap || !stickyPrice) return;
      var src = priceWrap.querySelector('.price__current') || priceWrap.querySelector('.bk-bb__price-value') || priceWrap;
      stickyPrice.innerHTML = src ? src.innerHTML : '';
    }
    // --- Verfuegbarkeit/Label vom echten CTA spiegeln (disabled = ausverkauft) ---
    function syncCta() {
      var disabled = mainCta.hasAttribute('disabled');
      stickyCta.disabled = disabled;
      var label = mainCta.querySelector('span');
      if (label && stickyLabel) stickyLabel.textContent = label.textContent.trim();
    }

    syncPrice();
    syncCta();

    if (priceWrap && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceWrap, { childList: true, subtree: true });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(syncCta).observe(mainCta, { attributes: true, childList: true, subtree: true });
    }

    // --- Proxy-Klick auf den echten CTA (uebernimmt Variante + Menge + Validierung) ---
    stickyCta.addEventListener('click', function () {
      if (stickyCta.disabled) return;
      mainCta.click();
    });

    // --- Sichtbarkeit: nur wenn die Haupt-Kaufzeile nach OBEN aus dem Viewport ist ---
    // (boundingClientRect.top < 0: nicht schon beim Seitenstart zeigen, wenn die
    // Buyrow noch UNTER dem Viewport liegt und der Nutzer sie nie gesehen hat)
    function show() { bar.removeAttribute('hidden'); bar.classList.add('is-visible'); }
    function hide() { bar.classList.remove('is-visible'); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
          else hide();
        });
      }, { rootMargin: '0px 0px -10% 0px' }).observe(buyrow);
    } else {
      show();
    }
  }

  function boot() {
    document.querySelectorAll('[data-bk-sticky-atc]').forEach(initBar);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Theme-Editor: Section-Reload
  document.addEventListener('shopify:section:load', boot);
})();
